import SmartContext from './SmartContext';

export default SmartContext;
